"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: {
    title: {
      type: String,
      default: '搜索框设置'
    },
    size: {
      type: String,
      default: '14px;'
    },
    is_tab: {
      type: Boolean,
      default: true
    }
  }
};
exports.default = _default;